export default "__VITE_ASSET__D9_k6Igt__"